/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
import React from 'react';

export const CustomSVG = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="160"
			height="170"
			viewBox="0 0 160 137"
			fill="none"
		>
			<g clipPath="url(#clip0_1719_8670)">
				<rect width="160" height="136.01" fill="white" fillOpacity="0.01" />
				<path d="M111.697 39.5325H14.3169V136.042H111.697V39.5325Z" fill="#CFD4DB" />
				<path
					d="M111.762 39.5325H41.4028V107.383H111.762V39.5325Z"
					fill="url(#paint0_linear_1719_8670)"
				/>
				<path d="M54.752 71.9065H31.6646V73.1963H54.752V71.9065Z" fill="white" />
				<path d="M54.752 64.2322H31.6646V65.522H54.752V64.2322Z" fill="white" />
				<path d="M44.1756 56.5579H31.6646V57.8477H44.1756V56.5579Z" fill="white" />
				<path d="M27.4084 56.5579H24.5708V57.8477H27.4084V56.5579Z" fill="white" />
				<path d="M27.4084 64.2322H24.5708V65.522H27.4084V64.2322Z" fill="white" />
				<path d="M27.4084 71.9065H24.5708V73.1963H27.4084V71.9065Z" fill="white" />
				<path d="M27.4084 79.5164H24.5708V80.8062H27.4084V79.5164Z" fill="white" />
				<path d="M27.4084 87.1907H24.5708V88.4805H27.4084V87.1907Z" fill="white" />
				<path d="M27.4084 94.8005H24.5708V96.0903H27.4084V94.8005Z" fill="white" />
				<path d="M27.4084 102.475H24.5708V103.765H27.4084V102.475Z" fill="white" />
				<path d="M27.4084 110.149H24.5708V111.439H27.4084V110.149Z" fill="white" />
				<path d="M27.4084 117.759H24.5708V119.049H27.4084V117.759Z" fill="white" />
				<path d="M98.9278 94.8005H59.5889V96.0903H98.9278V94.8005Z" fill="white" />
				<path d="M55.2034 94.8005H31.6646V96.0903H55.2034V94.8005Z" fill="white" />
				<path d="M102.668 102.475H69.198V103.765H102.668V102.475Z" fill="white" />
				<path d="M64.8771 102.475H44.1758V103.765H64.8771V102.475Z" fill="white" />
				<path d="M89.7058 110.149H44.1758V111.439H89.7058V110.149Z" fill="white" />
				<path d="M75.5179 117.759H56.6868V119.049H75.5179V117.759Z" fill="white" />
				<path d="M67.7792 79.5164H46.175V80.8062H67.7792V79.5164Z" fill="white" />
				<path d="M67.7792 87.1907H46.175V88.4805H67.7792V87.1907Z" fill="white" />
				<path
					d="M26.8925 88.6739C22.4064 88.6664 18.0228 90.0151 14.3169 92.5433V99.7017C16.5691 97.213 19.5091 95.4485 22.7647 94.6317C26.0203 93.8148 29.4451 93.9822 32.6054 95.1128C35.7658 96.2434 38.5197 98.2862 40.5184 100.983C42.5171 103.679 43.6708 106.908 43.8335 110.261C43.9962 113.613 43.1604 116.939 41.4321 119.816C39.7038 122.693 37.1607 124.993 34.1246 126.424C31.0885 127.856 27.696 128.354 24.3767 127.856C21.0573 127.358 17.9603 125.886 15.4777 123.628L14.3169 122.467V129.625C17.216 131.573 20.5309 132.816 23.9964 133.254C27.4618 133.691 30.9816 133.311 34.2739 132.145C37.5663 130.978 40.5398 129.057 42.9565 126.535C45.3732 124.013 47.166 120.96 48.1914 117.621C49.2167 114.282 49.4463 110.749 48.8615 107.306C48.2768 103.862 46.894 100.603 44.8239 97.7894C42.7538 94.976 40.0539 92.6862 36.9401 91.1033C33.8264 89.5204 30.3854 88.6884 26.8925 88.6739Z"
					fill="#CFD4DB"
				/>
				<path d="M149.617 0H52.2371V96.5095H149.617V0Z" fill="url(#paint1_linear_1719_8670)" />
				<path d="M92.6724 32.374H69.585V33.6638H92.6724V32.374Z" fill="#FFAB00" />
				<path d="M92.6724 24.6997H69.585V25.9895H92.6724V24.6997Z" fill="#0065FF" />
				<path d="M82.096 17.0254H69.585V18.3152H82.096V17.0254Z" fill="#E5E8EC" />
				<path d="M65.2641 17.0254H62.4265V18.3152H65.2641V17.0254Z" fill="#E5E8EC" />
				<path d="M65.2641 24.6997H62.4265V25.9895H65.2641V24.6997Z" fill="#E5E8EC" />
				<path d="M65.2641 32.374H62.4265V33.6638H65.2641V32.374Z" fill="#E5E8EC" />
				<path d="M65.2641 39.9839H62.4265V41.2737H65.2641V39.9839Z" fill="#E5E8EC" />
				<path d="M65.2641 47.6582H62.4265V48.948H65.2641V47.6582Z" fill="#E5E8EC" />
				<path d="M65.2641 55.2681H62.4265V56.5579H65.2641V55.2681Z" fill="#E5E8EC" />
				<path d="M65.2641 62.9424H62.4265V64.2322H65.2641V62.9424Z" fill="#E5E8EC" />
				<path d="M65.2641 70.6167H62.4265V71.9065H65.2641V70.6167Z" fill="#E5E8EC" />
				<path d="M65.2641 78.2266H62.4265V79.5164H65.2641V78.2266Z" fill="#E5E8EC" />
				<path d="M136.784 55.2681H97.4446V56.5579H136.784V55.2681Z" fill="#FFAB00" />
				<path d="M93.1238 55.2681H69.585V56.5579H93.1238V55.2681Z" fill="#E5E8EC" />
				<path d="M140.589 62.9424H107.118V64.2322H140.589V62.9424Z" fill="#FFAB00" />
				<path d="M102.733 62.9424H82.0315V64.2322H102.733V62.9424Z" fill="#0065FF" />
				<path d="M127.562 70.6167H82.0315V71.9065H127.562V70.6167Z" fill="#0065FF" />
				<path d="M113.374 78.2266H94.5425V79.5164H113.374V78.2266Z" fill="#E5E8EC" />
				<path d="M105.699 39.9839H84.0952V41.2737H105.699V39.9839Z" fill="#E5E8EC" />
				<path d="M105.699 47.6582H84.0952V48.948H105.699V47.6582Z" fill="#E5E8EC" />
				<path
					opacity="0.5"
					d="M149.617 42.5635C146.76 39.1832 142.965 36.726 138.711 35.5028C134.457 34.2795 129.937 34.3451 125.72 35.6912C121.504 37.0373 117.781 39.6035 115.024 43.0653C112.266 46.5271 110.596 50.7289 110.226 55.1395C109.857 59.55 110.803 63.9712 112.946 67.8438C115.089 71.7165 118.332 74.8668 122.265 76.8962C126.199 78.9256 130.646 79.7431 135.044 79.2452C139.441 78.7474 143.593 76.9565 146.973 74.0991C147.918 73.2834 148.801 72.3997 149.617 71.4551V42.5635ZM132.527 73.9702C129.173 73.9702 125.894 72.9754 123.104 71.1117C120.315 69.2481 118.141 66.5991 116.857 63.4999C115.574 60.4007 115.238 56.9904 115.892 53.7004C116.547 50.4103 118.162 47.3881 120.534 45.0161C122.906 42.6441 125.928 41.0287 129.218 40.3743C132.509 39.7198 135.919 40.0557 139.018 41.3394C142.117 42.6232 144.766 44.7971 146.63 47.5863C148.493 50.3755 149.488 53.6547 149.488 57.0093C149.488 61.5076 147.701 65.8216 144.52 69.0024C141.34 72.1832 137.026 73.9702 132.527 73.9702Z"
					fill="#091E42"
				/>
				<path
					d="M9.52356 120.586L-0.0527344 130.162L2.68335 132.898L12.2596 123.322L9.52356 120.586Z"
					fill="#0065FF"
				/>
				<path
					d="M135.752 73.4545C146.615 73.4545 155.421 64.6481 155.421 53.785C155.421 42.9218 146.615 34.1155 135.752 34.1155C124.889 34.1155 116.083 42.9218 116.083 53.785C116.083 64.6481 124.889 73.4545 135.752 73.4545Z"
					fill="#344563"
				/>
				<path d="M140.524 55.9775H115.244V59.8469H140.524V55.9775Z" fill="#FDC150" />
				<path d="M140.524 43.7888H117.824V47.6582H140.524V43.7888Z" fill="#FAFBFC" />
				<path
					opacity="0.5"
					d="M155.421 53.7849C155.421 53.0755 155.421 52.4306 155.357 51.7212C153.422 45.8484 149.249 40.976 143.742 38.1626C138.236 35.3491 131.842 34.8217 125.95 36.695C122.955 38.4166 120.466 40.8964 118.734 43.8852C117.002 46.8739 116.087 50.2661 116.083 53.7204C116.748 51.4545 117.857 49.3437 119.347 47.5108C120.836 45.678 122.675 44.1598 124.756 43.0448C126.838 41.9297 129.121 41.2401 131.472 41.016C133.823 40.7919 136.195 41.0379 138.45 41.7396C140.705 42.4413 142.797 43.5847 144.606 45.1032C146.415 46.6217 147.903 48.485 148.984 50.5844C150.066 52.6838 150.718 54.9774 150.905 57.3316C151.091 59.6858 150.807 62.0535 150.069 64.2968C149.446 66.2418 148.51 68.0718 147.296 69.714C149.812 67.8898 151.861 65.4951 153.273 62.7262C154.686 59.9574 155.422 56.8932 155.421 53.7849Z"
					fill="#091E42"
				/>
				<path
					d="M135.752 75.3891C131.479 75.3891 127.302 74.122 123.749 71.7481C120.196 69.3742 117.427 66.0001 115.792 62.0524C114.157 58.1048 113.729 53.7609 114.563 49.5701C115.396 45.3793 117.454 41.5298 120.475 38.5084C123.497 35.487 127.346 33.4294 131.537 32.5958C135.728 31.7622 140.072 32.19 144.019 33.8252C147.967 35.4604 151.341 38.2294 153.715 41.7822C156.089 45.335 157.356 49.512 157.356 53.7849C157.356 59.5147 155.08 65.0098 151.028 69.0613C146.977 73.1129 141.482 75.3891 135.752 75.3891ZM135.752 36.0501C132.244 36.0501 128.815 37.0902 125.899 39.0389C122.983 40.9877 120.709 43.7574 119.367 46.9981C118.025 50.2387 117.674 53.8045 118.358 57.2447C119.042 60.685 120.731 63.845 123.212 66.3252C125.692 68.8055 128.852 70.4946 132.292 71.1789C135.732 71.8632 139.298 71.512 142.539 70.1697C145.779 68.8274 148.549 66.5543 150.498 63.6378C152.447 60.7213 153.487 57.2925 153.487 53.7849C153.487 49.0813 151.618 44.5704 148.292 41.2445C144.966 37.9186 140.455 36.0501 135.752 36.0501Z"
					fill="#0065FF"
				/>
				<path
					d="M25.022 127.368C35.8852 127.368 44.6915 118.562 44.6915 107.699C44.6915 96.8354 35.8852 88.0291 25.022 88.0291C14.1589 88.0291 5.35254 96.8354 5.35254 107.699C5.35254 118.562 14.1589 127.368 25.022 127.368Z"
					fill="#E5E8EC"
				/>
				<path d="M34.3088 116.018H22.8296V119.887H34.3088V116.018Z" fill="white" />
				<path d="M34.3088 103.894H22.8296V107.763H34.3088V103.894Z" fill="white" />
				<path d="M33.7929 91.7048H22.8296V95.5742H33.7929V91.7048Z" fill="white" />
				<path
					opacity="0.2"
					d="M27.9241 88.2224C22.3303 88.4082 16.9857 90.5811 12.8492 94.3512C8.71263 98.1214 6.05482 103.242 5.35254 108.795C5.56904 112.683 6.93485 116.419 9.27691 119.531C11.619 122.642 14.8319 124.988 18.5085 126.272C16.469 124.997 14.7089 123.323 13.3345 121.349C11.96 119.375 10.9998 117.144 10.5118 114.789C10.0238 112.434 10.018 110.005 10.4949 107.647C10.9718 105.29 11.9215 103.054 13.2866 101.074C14.6517 99.094 16.4038 97.4111 18.4373 96.1271C20.4708 94.843 22.7435 93.9843 25.118 93.6029C27.4925 93.2215 29.9198 93.3253 32.2531 93.908C34.5864 94.4906 36.7775 95.5401 38.6939 96.9931C40.9284 98.5049 42.7826 100.514 44.1111 102.862C43.1368 99.1077 41.0848 95.7211 38.2084 93.1196C35.3319 90.5182 31.7568 88.8158 27.9241 88.2224Z"
					fill="#091E42"
				/>
				<path
					d="M25.0222 129.303C20.7493 129.303 16.5723 128.036 13.0195 125.662C9.46673 123.288 6.69767 119.914 5.0625 115.966C3.42733 112.018 2.99949 107.674 3.8331 103.484C4.6667 99.2929 6.7243 95.4434 9.7457 92.422C12.7671 89.4006 16.6166 87.343 20.8074 86.5094C24.9982 85.6758 29.3421 86.1036 33.2897 87.7388C37.2374 89.3739 40.6115 92.143 42.9854 95.6958C45.3593 99.2486 46.6264 103.426 46.6264 107.698C46.6264 113.428 44.3502 118.923 40.2986 122.975C36.2471 127.026 30.752 129.303 25.0222 129.303ZM25.0222 89.9637C21.5146 89.9637 18.0857 91.0038 15.1693 92.9525C12.2528 94.9012 9.97967 97.671 8.63737 100.912C7.29506 104.152 6.94385 107.718 7.62815 111.158C8.31246 114.599 10.0015 117.759 12.4818 120.239C14.962 122.719 18.1221 124.408 21.5623 125.092C25.0025 125.777 28.5684 125.426 31.809 124.083C35.0496 122.741 37.8194 120.468 39.7681 117.551C41.7168 114.635 42.757 111.206 42.757 107.698C42.757 102.995 40.8885 98.484 37.5626 95.1581C34.2366 91.8321 29.7257 89.9637 25.0222 89.9637Z"
					fill="#0065FF"
				/>
				<path
					d="M150.447 66.7551L147.71 69.4912L157.268 79.0493L160.005 76.3132L150.447 66.7551Z"
					fill="#0065FF"
				/>
			</g>
			<defs>
				<linearGradient
					id="paint0_linear_1719_8670"
					x1="76.5628"
					y1="107.383"
					x2="76.5628"
					y2="10.8731"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#E5E8EC" stopOpacity="0.1" />
					<stop offset="0.08" stopColor="#E1E4E9" stopOpacity="0.27" />
					<stop offset="0.18" stopColor="#DCE0E5" stopOpacity="0.46" />
					<stop offset="0.29" stopColor="#D8DCE2" stopOpacity="0.63" />
					<stop offset="0.4" stopColor="#D5D9DF" stopOpacity="0.76" />
					<stop offset="0.53" stopColor="#D2D7DD" stopOpacity="0.87" />
					<stop offset="0.66" stopColor="#D0D5DC" stopOpacity="0.94" />
					<stop offset="0.8" stopColor="#CFD4DB" stopOpacity="0.99" />
					<stop offset="1" stopColor="#CFD4DB" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_1719_8670"
					x1="52.437"
					y1="96.7287"
					x2="149.379"
					y2="-0.219268"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#172B4D" />
					<stop offset="0.58" stopColor="#192D4E" />
					<stop offset="0.78" stopColor="#203354" />
					<stop offset="0.93" stopColor="#2B3D5C" />
					<stop offset="1" stopColor="#344563" />
				</linearGradient>
				<clipPath id="clip0_1719_8670">
					<rect width="160" height="136.01" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};
